// Archivo: ./src/Components/Tienda/ThemeInjector.js
import React, { useEffect } from 'react';

function ThemeInjector({ configuracion }) {
    
    // Usamos useEffect para aplicar los estilos al DOM
    useEffect(() => {
        if (configuracion) {
            const root = document.documentElement.style; // Apunta a la etiqueta <html>
            
            // Aplicamos los colores como variables CSS globales
            root.setProperty('--primary-color', configuracion.colorPrimario || '#007bff'); // Fallback a azul de Bootstrap
            root.setProperty('--secondary-color', configuracion.colorSecundario || '#6c757d');
            
            // Aplicar fuente
            document.body.style.fontFamily = configuracion.fuente || "'Helvetica Neue', Arial, sans-serif";
            
            // Opcional: Para cambiar el color de fondo de toda la aplicación
            // document.body.style.backgroundColor = configuracion.colorFondo || '#ffffff';
        }
    }, [configuracion]);
    
    // Este componente no renderiza nada visual, solo aplica estilos
    return null; 
}
export default ThemeInjector;